import Dispatcher from "../Dispatcher";
import {ShoppingBasket} from "../models/ShoppingBasket";
import {PaymentRequest} from "../models/PaymentRequest";
import {ShippingRate} from "../models/ShippingRate";
import {ShoppingBasketLineItem} from "../models/ShoppingBasketLineItem";
import {ShoppingBasketPrice} from "../models/ShoppingBasketPrice";
import {Address} from "../models/Address";
import {ShoppingBasketAction} from "../actions/ShoppingBasketActions";
import {Store} from "flux/utils";
import $ = require("jquery");

let basket = new ShoppingBasket();
let errors = "";
let promoError = "";
let productQuantity = 1;
let baseApiUrl = window.emanagerBaseApiAddress;
let websiteId = window.websiteId;
let basketId = window.shoppingBasketId;
let _notes: Array<string> = [];

class ShoppingBasketStore extends Store<ShoppingBasketAction<ShoppingBasket>>
{
	private ensureBasketId(forceRefresh: boolean)
	{
		if (basketId !== undefined && basketId !== null && !forceRefresh)
		{
			return;
		}
		console.warn("SHOPPING BASKET WARNING: Global basketID var is UNDEFINED going to reparse cookie");
		basketId = this.readCookie("EMBSK");
	}
	private ensureWebsiteId()
	{
		if(!websiteId)
			websiteId = window.websiteId;
		if(!baseApiUrl)
			baseApiUrl = window.emanagerBaseApiAddress;
	}
	private readCookie(name: string)
	{
		var nameEq = name + "=";
		var ca = document.cookie.split(";");
		for (var i = 0; i < ca.length; i++)
		{
			var c = ca[i];
			while (c.charAt(0) === " ")
			{
				c = c.substring(1, c.length);
			}
			if (c.indexOf(nameEq) === 0)
			{
				return c.substring(nameEq.length, c.length);
			}
		}
		return null;
	}

	getBasket()
	{
		return basket;
	}
	
	getErrors()
	{
		return errors;
	}
	getPromoError()
	{
		return promoError;
	}
	
	getQuantity()
	{
		return productQuantity;
	}

	setQuantityValue(value: number)
	{
		productQuantity = value;
	}

	private setCookie(value: string, days: any)
	{
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		var expires = "; expires=" + date.toUTCString();
		document.cookie ="EMBSK=" + value + expires + "; path=/";
	}

	logonDataPasses()
	{
		var cookie = this.readCookie("EMAD");
		if (cookie !== "" && cookie !== null && cookie !== undefined)
		{
			var username = this.readCookie("username");
			if (username === "" || username === null || username === undefined)
			{
			return false;
			}
		}
		else
		{
			var username = this.readCookie("username");
			if (username !== "" && username !== null && username !== undefined)
			{
			return false;
			}
		}
		return true;
	}

	invalidCustomerBasket()
	{
		if (basket.customer.emailAddress !== "" && basket.customer.emailAddress !== null && basket.customer.emailAddress !== undefined && !basket.configuration.isAnonymousCheckoutEnabled)
		{
			let emad = this.readCookie("EMAD");
			let username = this.readCookie("username");
			if (emad === "" || emad === null || emad == undefined)
			{
			if (username === "" || username === null || username === undefined)
			{
				return true;
			}
			return false;
			}
			return false;
		}
		return false;
	}

	reloadInvalidBasket()
    {
        window["shoppingBasketId"] = "000000000000000000000000";
        window["shoppingCartId"] = "000000000000000000000000";
        this.setCookie("000000000000000000000000",1);
        this.loadBasketFromServer(true);
    }

	loadBasketFromServer(changeGlobalId: boolean = false)
	{
		this.ensureBasketId(changeGlobalId);
		this.ensureWebsiteId();
		return $.ajax({
			url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId}?_t=${(new Date()).getTime()}`,
			contentType: "application/json",
			method: "GET"
		})
			.done((basket: ShoppingBasket) =>
			{
				if (basketId !== basket.id)
				{
					basketId = basket.id;
					window.shoppingBasketId = basket.id;
					window["shoppingCartId"] = basket.id;
					this.setCookie(basket.id,30);
					this.loadBasketFromServer();
					return;
				}
				basketId = basket.id;

				window.customerId = basket.customer.id;
				if (changeGlobalId)
				{
					window.shoppingBasketId = basket.id;
					window["shoppingCartId"] = basket.id;
					this.setCookie(basket.id,30);
				}
				this.setupBasket(basket);
				errors = "";
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_UPDATED", basket));
			});
	}

	setEmailAddressForAnon(email: string | number)
	{
		this.ensureWebsiteId();
		return $.ajax({
			url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId
			}/customer/000000000000000000000000?emailAddress=${email}`,
			contentType: "application/json",
			method: "PUT"
		})
		.fail((jsonError: any) =>{
			var error = jsonError.responseJSON.message;
			if (error.indexOf("out of stock") !== -1)
			{
				errors = error;
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_FAILED", basket));
			}
		})
			.done((basket: ShoppingBasket) =>
			{
				this.setupBasket(basket);
				errors = "";
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_UPDATED", basket));
			});
	}

	setShippingRate(shippingRate: ShippingRate)
	{
		this.ensureWebsiteId();
		return $.ajax({
			url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId
			}/assignshippingrate`,
			contentType: "application/json",
			method: "PUT",
			data: JSON.stringify(shippingRate)
		})
.fail((jsonError: any) =>{
var error = jsonError.responseJSON.message;
			if (error.indexOf("out of stock") !== -1)
			{
				errors = error;
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_FAILED", basket));
			}
		})
			.done((basket: ShoppingBasket) =>
			{
				this.setupBasket(basket);
				errors = "";
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_UPDATED", basket));
			});
	}

	setLineItemQuantity(sku: string, amount: number)
	{
		this.ensureWebsiteId();
		return $.ajax({
			url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId}/lineitem/${sku
			}/qty/${amount}`,
			contentType: "application/json",
			method: "PUT"
		})
.fail((jsonError: any) =>{
var error = jsonError.responseJSON.message;
			if (error.indexOf("out of stock") !== -1)
			{
				errors = error;
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_FAILED", basket));
			}
		})
			.done((basket: ShoppingBasket) =>
			{
				this.setupBasket(basket);
				errors = "";
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_UPDATED", basket));
			});
	}

	setShippingAccountNumber(accountNumber: string)
	{
		this.ensureWebsiteId();
		$.ajax({
			url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId
			}/assignshippingaccount%3FshippingAccount=${accountNumber}`,
			contentType: "application/json",
			method: "PUT"
		})
.fail((jsonError: any) =>{
var error = jsonError.responseJSON.message;
			if (error.indexOf("out of stock") !== -1)
			{
				errors = error;
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_FAILED", basket));
			}
		})
			.done((basket: ShoppingBasket) =>
			{
				this.setupBasket(basket);
				errors = "";
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_UPDATED", basket));
			});
	}

	addAddressToCustomer(newAddress: Address): any
	{
		this.ensureWebsiteId();
		return $.ajax(
			{
				url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId}/createAddress`,
				contentType: "application/json",
				method: "POST",
				data: JSON.stringify(newAddress)
			}).fail((jsonError:any) =>{
var error = jsonError.responseJSON.message;
			if (error.indexOf("out of stock") !== -1)
			{
				errors = error;
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_FAILED", basket));
			}
		}).done((basket: ShoppingBasket) =>
			{
				this.setupBasket(basket);
				errors = "";
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_UPDATED", basket));
			});
	}

	removeAddressFromCustomer(address: Address)
	{
		this.ensureWebsiteId();
		return $.ajax(
			{
				url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId}/removeAddress`,
				contentType: "application/json",
				method: "DELETE",
				data: JSON.stringify(address)
			}).fail((jsonError:any) =>{
			var error = jsonError.responseJSON.message;
			if (error.indexOf("out of stock") !== -1)
			{
				errors = error;
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_FAILED", basket));
			}
		}).done((basket: ShoppingBasket) =>
			{
				this.setupBasket(basket);
				errors = "";
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_UPDATED", basket));
			});
	}

	assignPerferredAddress(address: Address, type: string)
	{
		this.ensureWebsiteId();
		return $.ajax(
			{
				url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId}/perferredAddress/${
				type}`,
				contentType: "application/json",
				method: "PUT",
				data: JSON.stringify(address)
			}).fail((jsonError: any) =>{
			var error = jsonError.responseJSON.message;
			if (error.indexOf("out of stock") !== -1)
			{
				errors = error;
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_FAILED", basket));
			}
		}).done((basket: ShoppingBasket) =>
			{
				this.setupBasket(basket);
				errors = "";
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_UPDATED", basket));
			});
	}
	addNote(note: string)
	{
		_notes.push(note);
	}

	addPromoCode(code: string)
	{
		this.ensureWebsiteId();
		return $.ajax(
			{
				url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId}/promoCode/${
				code}/add`,
				contentType: "application/json",
				method: "PUT"
			}).fail((jsonError: any) =>{
				promoError = "Could not add the promo code";
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_FAILED", basket));
		}).done((basket: ShoppingBasket) =>
			{
				if (basket.promoCode === "")
				{
					promoError = "The entered promo code could not be added.";
					this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_FAILED", basket));
				}
				else promoError = "";
				this.setupBasket(basket);			
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_UPDATED", basket));
			});
	}

	removePromoCode()
	{
		this.ensureWebsiteId();
		return $.ajax(
			{
				url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId}/promoCode/remove`,
				contentType: "application/json",
				method: "DELETE"
			}).fail((jsonError: any) =>{
				console.log("failed to remove the promo code!!!!");
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_FAILED", basket));
		}).done((basket: ShoppingBasket) =>
			{
				this.setupBasket(basket);			
				this.getDispatcher().dispatch(new ShoppingBasketAction("BASKET_UPDATED", basket));
			});
	}

	performCheckout(payment: PaymentRequest, note: string, isTaxExempt: boolean)
	{
		this.ensureWebsiteId();
		payment.websiteId = websiteId;
		payment.shoppingBasketId = basketId;
		payment.storeId = window.storeId;
		var preCheckout: Array<JQueryPromise<any>> = [];

		var notes: string = _notes.join('\n') + note;
		var notesJob =
			{
				url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId}/assignnote?note=${notes}`,
				contentType: "application/json",
				method: "PUT"
			};
		var taxJob =
			{
				url: `${baseApiUrl}website/${websiteId}/store/000000000000000000000000/shoppingbasket/${basketId}/assigntaxexempt/${
				isTaxExempt}`,
				contentType: "application/json",
				method: "PUT"
			};


		var job =
			{
				type: "POST",
				dataType: "json",
				contentType: "application/json",
				data: JSON.stringify(payment),
				xhrFields: { withCredentials: false },
				url: window.emanagerGatewayAddress
			};

		function deferred()
		{
			let promise = $.Deferred();
			$.ajax(notesJob).done(() =>
			{
				$.ajax(taxJob).done((basket) =>
				{
					$.ajax(job).done((orderId) =>
					{
						promise.resolve(orderId);
					})
						.fail((fail: JQueryXHR) => { promise.reject(fail); });
				});;
			});
			return promise.promise();
		}

		return deferred();

		//var checkoutDeferred = $.Deferred();
		//checkoutDeferred.promise($.ajax(job));
		//return $.when($.ajax(notesJob)).then(() => {
		//	return $.when($.ajax(taxJob));
		//}).then(() => {
		//	checkoutDeferred.resolve()
		//});
	}

	private setupBasket(basket: ShoppingBasket)
	{
		this.sortLineItems(basket);
		this.handleTbdShippingTax(basket);
		this.assignDiscountPrice(basket);
	}

	private sortLineItems(basket: ShoppingBasket)
	{
		let lineItems = basket.lineItems;
		basket.lineItems = lineItems.sort((a, b) =>
		{
			if (a.sku < b.sku)
			{
				return -1;
			}
			if (a.sku > b.sku)
			{
				return 1;
			}
			return 0;
		});
	}

	private assignDiscountPrice(basket: ShoppingBasket)
	{
		for (let i = 0; i < basket.lineItems.length; i++)
		{
			const lineItem = basket.lineItems[i];
			lineItem.discountPrice = this.findDiscountPrice(basket, lineItem);
			lineItem.hasDiscount = lineItem.discountPrice != null;
			lineItem.originalPrice = this.getProductPrice(lineItem);
		}
	}

	private findDiscountPrice(basket: ShoppingBasket, lineItem: ShoppingBasketLineItem)
	{
		const sku = lineItem.sku;
		const priceAdjustments = basket.priceAdjustments;
		let i = 0;
		const l = priceAdjustments.length;
		for (; i < l; i++)
		{
			const adjustment = priceAdjustments[i];
			const adjSku = adjustment.appliesToSKU;
			const adjCat = adjustment.category;
			if (adjSku === sku && (adjCat === "ProductDiscount" || adjCat === "CustomCustomerDiscount"))
			{
				const basePrice = this.getProductPrice(lineItem);
				return Math.abs(basePrice + adjustment.amount / lineItem.quantity);
			}
		}
		return null;
	}

	private getProductPrice(lineItem: ShoppingBasketLineItem)
	{
		let price = 0;
		if (lineItem == null)
		{
			return price;
		}
		const sku = lineItem.sku;
		const product = lineItem.product;
		price = product.prices[0].amount;
		const skuFrags = sku.split("-");
		const isSyntheticSku = skuFrags.length > 1;
		if (!isSyntheticSku)
		{
			return price;
		}
		let attributes = product.attributes || [];
		attributes = attributes.sort((a, b) =>
		{
			const aorder = a.skuFragmentOrder;
			const border = b.skuFragmentOrder;
			return aorder - border;
		});
		for (let i = 1; i < skuFrags.length; i++)
		{
			const skuFrag = skuFrags[i];
			for (let j = 0; j < attributes.length; j++)
			{
				const attribute = attributes[j];
				const skuFragId = attribute.skuFragment;
				if (skuFrag === skuFragId)
				{
					price += attribute.costAdjustment;
					break;
				}
			}
		}
		return price;
	};

	private handleTbdShippingTax(basket: ShoppingBasket)
	{
		function findTbd(priceType: string, prices: Array<ShoppingBasketPrice>)
		{
			let i = 0;
			const l = prices.length;
			for (; i < l; i++)
			{
				const price = prices[i];
				const name = price.category;
				if (name === priceType)
				{
					if (price.istbd)
					{
						return true;
					}
				}
			}
			return false;
		}

		const prices = basket.priceAdjustments;
		const isShippingTbd = findTbd("Shipping", prices);
		const isTaxTbd = findTbd("Tax", prices);
		basket.isShippingTBD = isShippingTbd;
		basket.isTaxTBD = isTaxTbd;
	};

	// ReSharper disable once InconsistentNaming required because of base class
	__onDispatch(action: ShoppingBasketAction<any>)
	{
		switch (action.type)
		{
			case "BASKET_UPDATED":
				{
					basket = action.value as ShoppingBasket;
					this.__emitChange();
					break;
				}
			case "BASKET_FAILED":
			{
					basket = action.value as ShoppingBasket;
					this.__emitChange();
					break;
			}
			default:
		}
	}
}

export default new ShoppingBasketStore(Dispatcher);


// WEBPACK FOOTER //
// ./src/stores/ShoppingBasketStore.ts